/**
 * Created by Alex Xia on 19/03/2019.
 * Description:
 *  Float button
 * ------ maintenance history ------
 * 06/28/2019 Bowen Li  make the float menu drage
 */
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ElementRef, Renderer2, HostBinding, ChangeDetectorRef } from '@angular/core';
import { FloatMenuService } from '../../services/float-menu.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux';
import { getDraftListState } from '../../redux/reducers/draft-view.reducer';
import { Subscription } from 'rxjs';
import { DataList } from '../../tamalelibs/models/data-list.model';
import { Thread } from '../../tamalelibs/models/thread.model';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'float-menu-draft-count',
    templateUrl: './float-menu-draft-count.component.html',
    styleUrls: ['./float-menu-draft-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [trigger('draggingMenu', [transition('1 => 0', [style({
        top: '{{top}}', left: '{{left}}', right: '{{right}}', bottom: '{{bottom}}'
    }
    ), animate('0ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style({
        transform: 'scale(1)'
    }
    )), animate('100ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style('*'))])]), trigger('menuState', [transition(':enter', [style({
        transform: 'scale(0)'
    }
    ),
    ]), transition(':leave', [animate('0ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style({
        transform: 'scale(0)'
    }
    ))])])],
    providers: [
    ]
})
export class FloatMenuDraftCountComponent implements OnInit, OnDestroy {
    // Binding host element to @menuState animation
    @HostBinding('@menuState') public menuState = false;

    // for draggingMenu animation
    top: string;
    left: string;
    bottom: string;
    right: string;
    defaultPosition = 'bottomRight';
    selectPosition = 'bottomRight';
    floatMenuWidth = 240;
    floatMenuHeight = 43;
    draftCount = 0;

    private _destroySubscriptions: Array<Subscription> = [];
    // for draggingMenu animation
    private _left: number;
    private _top: number;
    private _centreX: number;
    private _isDragging = false;

    constructor(
        public _floatMenuService: FloatMenuService,
        private _store: Store<AppState>,
        private _element: ElementRef,
        private _renderer2: Renderer2,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._store.pipe<any>(
                select(getDraftListState)
            ).subscribe(res => this._onSubscribeDraftListItem(res))
        );
        // need to initial the float menu positon
        this.setFloatMenuPosition(this.defaultPosition);
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    // float menu start move
    onPanStart(): void {
        this._isDragging = true;
    }

    // float menu move end
    onPanEnd(): void {
        this._centreX = window.innerWidth / 2 - this.floatMenuWidth / 2;
        if (this._left < this._centreX) {
            this.selectPosition = 'bottomLeft';
        } else {
            this.selectPosition = 'bottomRight';
        }
        // reset host's position
        this.setFloatMenuPosition(this.selectPosition); // reset the panMove flag and start the @draggingMenu animation
        this._isDragging = false;
    }

    // float menu is moving
    onMenuMove(event: any): void {
        if (this._isDragging) {
            const y = event.center.y;
            const x = event.center.x;
            this._top = y - this.floatMenuHeight / 2;
            this.top = this._top + 'px';
            this._left = x - this.floatMenuWidth / 2;
            this.left = this._left + 'px';
            this._renderer2.setStyle(this._element.nativeElement, 'top', this.top);
            this._renderer2.setStyle(this._element.nativeElement, 'left', this.left);
        }
    }

    showFloatMenuWithDraftList() {
        this._floatMenuService.floatMenuSubject$.next({
            onlyShowFloatMenu: false,
            draftCount: this.draftCount,
            position: this.selectPosition
        });
    }

    // Set host element's top and left position
    setFloatMenuPosition(positionName: string): void {
        if (positionName === 'bottomRight') {
            this._renderer2.setStyle(this._element.nativeElement, 'left', 'auto');
            this._renderer2.setStyle(this._element.nativeElement, 'right', '0px');
            this._renderer2.setStyle(this._element.nativeElement, 'top', 'auto');
            this._renderer2.setStyle(this._element.nativeElement, 'bottom', '0px');
        } else {
            this._renderer2.setStyle(this._element.nativeElement, 'left', '64px');
            this._renderer2.setStyle(this._element.nativeElement, 'right', 'auto');
            this._renderer2.setStyle(this._element.nativeElement, 'top', 'auto');
            this._renderer2.setStyle(this._element.nativeElement, 'bottom', '0px');
        }
        return;
    }

    private _onSubscribeDraftListItem(items: DataList<Thread>) {
        if (items) {
            this.draftCount = items.totalCount;
            this._changeDetectorRef.detectChanges();
        }
    }
}
